import React, {useEffect, useLayoutEffect, useState} from 'react';
import {useQuery} from "react-query";
import {getChats, getMsgById} from "../../../services/chatSvc";
import {IChatGroupItem} from "../../../types/chat";
import {ChatUsers} from "./components/ChatUsers";
import {useDispatch, useSelector} from "react-redux";
import {addMessage, clearMessages} from "../../../store/chatSlice";
import {API_HOSTNAME_URL} from "../../../mock/URLs";
import {getAuth} from "../../../modules/auth";
import useWebSocket from "../../../hooks/useWebSocket";
import {WsChatMessage} from "../../../types/message";
import ChatHeader from "./components/ChatHeader";
import ChatMessages from "./components/ChatMessages";
import ChatInput from "./components/ChatInput";

export const ChatSection = () => {
  const [selectedUser, setSelectedUser] = useState<IChatGroupItem | undefined>(undefined);
  const [searchChat, setSearchChat] = useState<string>("");
  const [sendMsg, setSendMsg] = useState<string>("");
  const scrollToBottomRef = React.useRef<HTMLDivElement>(null);
  const userId = selectedUser?.id || null;
  const dispatch = useDispatch();
  const storedMessage = useSelector((state: any) => state.chat.messages);

  const {
    data: chats,
    isLoading: chatsIsLoading,
  } = useQuery(["getChats", searchChat], () => getChats({
    params: {
      search: searchChat
    }
  }));

  const {
    data: userMessages,
    isLoading: userMsgIsLoading,
  } = useQuery(
      ['getMsgById', userId],
      async ({pageParam = 1}) => {
        if (!selectedUser) return null;
        return getMsgById({
          params: {
            page_size: 10,
            page: pageParam,
            chat_id: userId!
          },
        });
      }
  );

  const handleSendMsg = async () => {
    try {
      sendMessage(JSON.stringify({
        message: sendMsg
      }));
      setSendMsg('');
      scrollToBottom();
    } catch (e: any) {
    } finally {

    }
  };

  useEffect(() => {
    dispatch(clearMessages());
  }, [selectedUser]);

  const scrollToBottom = () => {
    if (scrollToBottomRef.current) {
      scrollToBottomRef.current.scrollTo({
        top: scrollToBottomRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };


  const wsUrl = selectedUser
      ? `wss://${API_HOSTNAME_URL}/ws/chat/${selectedUser.id}/?token=${getAuth()?.access}`
      : null;

  const {sendMessage, lastMessage, isConnected} = useWebSocket(wsUrl);

  const transformMessage = (msg: any): WsChatMessage => ({
    message_id: msg.id,
    chat: {
      id: msg.chat.id,
      name: msg.chat.name,
    },
    sender: {
      id: msg.sender.id,
      first_name: msg.sender.first_name,
      last_name: msg.sender.last_name,
      avatar: msg.sender.avatar,
    },
    message: msg.message,
    created_at: msg.created_at,
    updated_at: msg.updated_at,
    is_admin: msg.is_admin,
    is_sent: msg.is_sent,
  });

  useLayoutEffect(() => {
    if (lastMessage) {
      const parsedMessage = JSON.parse(lastMessage);
      const transformedMessage = transformMessage(parsedMessage);
      dispatch(addMessage(transformedMessage));
    }
    scrollToBottom();
  }, [lastMessage]);

  useLayoutEffect(() => {
    if (userMessages?.data) {
      userMessages.data.forEach((msg) => {
        const transformedMessage = transformMessage(msg);
        dispatch(addMessage(transformedMessage));
      });
    }
    scrollToBottom();

  }, [userMessages]);

  return (
      <div>
        <div>
          <div className="d-flex flex-column flex-lg-row align-items-stretch">
            <ChatUsers chatsIsLoading={chatsIsLoading} searchChat={searchChat}
                       selectedUser={selectedUser!} setSearchChat={setSearchChat}
                       setSelectedUser={setSelectedUser} chats={chats!}/>

            <div className="flex-lg-row-fluid ms-lg-7 ms-xl-10">
              {selectedUser ?
                  <div className="card overflow-hidden" style={{height: "87vh"}} id="kt_chat_messenger">
                    <ChatHeader selectedUser={selectedUser}/>
                    <ChatMessages userMsgIsLoading={userMsgIsLoading} storedMessage={storedMessage}
                                  scrollToBottomRef={scrollToBottomRef}/>
                    <ChatInput isConnected={isConnected} sendMsg={sendMsg} setSendMsg={setSendMsg}
                               handleSendMsg={handleSendMsg}/>
                  </div> :
                  <div className={"card d-flex user-select-none justify-content-center align-items-center"}
                       style={{height: "83vh"}}>
                    <p className={"badge badge-light"}>
                      Chat boshlash uchun chat tanlang
                    </p>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
  );
};